/* eslint-disable relay/unused-fields */
import { graphql } from 'react-relay';

export const checkoutItemBuyerQuery = graphql`
    query checkoutItemBuyerQuery(
        $itemId: String!
        $itemIds: [String]
        $skuIds: [String]
        $skuId: String
        $emailUserId: String = ""
        $hasEmailUserId: Boolean!
        $buyerId: String = ""
        $buyerIds: [String]!
        $hasBuyerId: Boolean!
        $userIds: [String]!
        $hasUserId: Boolean!
        $hasTradeStatus: Boolean!
        $isMobile: Boolean!
        $hasSessionUserGeoInfo: Boolean!
        $userCountryCode: String = ""
        $partialAddressCheckoutEligibility: String!
    ) {
        viewer {
            id
            ...CheckoutGuestBuyerQueryRenderer_viewer
            userTokenCanCheckout(userId: $buyerId) @include(if: $hasBuyerId)
            item(itemId: $itemId, pageType: CHECKOUT) {
                ...CheckoutGuestBuyerQueryRenderer_item
                serviceId
                title
                isSold
                isOnHold(buyerId: $buyerId)
                isDeleted
                isNotListed
                isPriceUponRequest
                isAuctionEnabled
                hasNetPrice
                seller {
                    isSuspended
                    isOpopSuspended
                    isPending
                    isClosed
                }
                classification {
                    categories {
                        category {
                            browseUrl
                        }
                    }
                }
                relevantAuctionSolution(page: checkout) {
                    highestBidderId
                    bids {
                        totalResults
                    }
                }
                relevantAuctionLot(page: checkout) {
                    isOpen
                    buyItNowPrice {
                        __typename
                    }
                }
            }
            emailUser: user(userId: $emailUserId) @include(if: $hasEmailUserId) {
                ...CheckoutGuestBuyerQueryRenderer_emailUser
            }
            user(userId: $buyerId) @include(if: $hasBuyerId) {
                serviceId
                isTrade: isVerifiedTrade
                ...CheckoutGuestBuyerQueryRenderer_buyer
            }
            preCheckoutTransaction: transactions(
                first: 1
                itemId: $itemIds
                skuId: $skuIds
                buyerId: $buyerIds
                viewName: "buyer.checkoutOffer"
                sort: "createdDate desc"
            ) @include(if: $hasBuyerId) {
                edges {
                    node {
                        ...CheckoutGuestBuyerQueryRenderer_preCheckoutTransaction
                        canBuyerAcceptPrivateOffer
                        isMostRecentlyDealerCountered
                        isPrivateOffer
                        isSecondChanceOfferActive
                        mostRecentOffer {
                            canUseOfferForCheckout
                        }
                        mostRecentBuyerOffer {
                            canUseOfferForCheckout
                            isDealerInitiated
                            isAccepted
                        }
                    }
                }
            }
            existingTransaction: transactions(
                first: 1
                itemId: $itemIds
                buyerId: $buyerIds
                viewName: "buyer.existingTransaction"
                sort: "createdDate desc"
            ) @include(if: $hasBuyerId) {
                totalResults
                edges {
                    node {
                        serviceId
                    }
                }
            }
        }
    }
`;
